import {
  Directive,
  ElementRef, HostBinding, Inject,
  Optional
} from '@angular/core';
import {ABSOLUTE_DRAG_HANDLE, ABSOLUTE_DRAG_PARENT} from '@shared/absolute-drag/injection-tokens';
import {AbsoluteDragDirective} from '@shared/absolute-drag/absolute-drag.directive';


@Directive({
  selector: '[absoluteDragHandle]',
  providers: [{provide: ABSOLUTE_DRAG_HANDLE, useExisting: AbsoluteDragHandleDirective}],
})
export class AbsoluteDragHandleDirective{
  public parentDragDirective: AbsoluteDragDirective | undefined;

  @HostBinding('class') get adhClass() {
    return 'absolute-drag-handle';
  }

  constructor(public element: ElementRef<HTMLElement>,
              @Inject(ABSOLUTE_DRAG_PARENT) @Optional() parentDragDirective?: AbsoluteDragDirective) {

    this.parentDragDirective = parentDragDirective;
    if (this.parentDragDirective) {
      this.parentDragDirective.handleInstance = this;
    }
  }
}
